import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { openModal } from '../../../../../modules/actions/Modais'

import ImageLightBox from '../../../../../SPRINTA/third-party/ImageLightBox'

import ImageRatio from '../../../../../SPRINTA/atoms/AspectRatio'
import BoxAccordion from '../../../../../SPRINTA/atoms/BoxAccordion'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import { Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import { numberFormat } from '../../../../../SPRINTA/helpers/Formatter'
import { Select } from '../../../../../SPRINTA/atoms/Forms'
import FontIcon from '../../../../../SPRINTA/atoms/FontIcon'
import CartOrder from '../../../../organisms/CartOrder'
import Room from './Room'

import s from './style.css'
import Button from '../../../../../SPRINTA/atoms/Button';

class Accommodation extends Component {
    state = {
        loading: true,
        data: null,
        fullDescription: false,
        images: [],
        lightBox: false,
        indexImageLightBox: 0,
        guests: 1,
        cart: [],
        showCart: false,
        loadingSubmitCart: false
    }

    componentWillMount() {
        axios.get(`/events/get_accommodation/${this.props.event}/${this.props.id}`)
            .then(data => {

                let images = []
                data.images.forEach((element, key) => {
                    let image = `${window.config.url_event_extras_images}${element.image}`
                    images.push(image)
                })

                this.setState({
                    loading: false,
                    data,
                    images
                })
            })
    }

    openImage(key) {
        this.setState({
            indexImageLightBox: key,
            lightBox: true
        })
    }

    handleSetCart(cart) {
        this.setState({
            cart
        })
    }

    handleChosenRoom(id) {
        if (!this.props.login.isLogged) {
            this.props.openModal('modal-login')
            return
        }

        this.setState({
            loading: true
        }, () => {
            setTimeout(() => {

                let item = this.state.data.options.find(item => item.id === id)

                item.description = item.label
                item.value = parseFloat(item.value)
                item.guest_value = parseFloat(item.guest_value)

                item.price = item.value + ((this.state.guests - 1) * item.guest_value)
                item.quantity = 1
                item.option_label = item.daily_rate + " dia(s) para " + this.state.guests + " pessoa(s)"
                item.image = item.images[0] ? item.images[0].image : null
                item.guests = this.state.guests
                item.option = item.id
                item.id = this.props.id


                this.setState({
                    loading: false,
                    showCart: true,
                    cart: [item]
                })


            }, 600)
        })
    }

    handleSaveOrder() {
        let form = {}
        var i = 0
        this.state.cart.forEach(item => {
            form[`items[${i}][id]`] = item.id
            form[`items[${i}][option]`] = item.option
            form[`items[${i}][quantity]`] = item.quantity
            form[`items[${i}][guests]`] = item.guests
            i++
        })

        this.setState({
            loadingSubmitCart: true
        })

        axios.post(`/order/create/${this.props.event}`, form)
        .then(data => {
            window.location.href = `${window.URL_CHECKOUT}${data.token}`
        })
    }

    render() {
        if (this.state.loading)
            return <Loading />

        if (this.state.showCart)
            return (
                <div>
                    <span style={{cursor: 'pointer', position: 'relative', top: '-30px', right: '30px'}} onClick={() => this.setState({
                        showCart: false
                    })}>
                      <FontIcon size={13} name="left-arrow" />
                    </span>

                    <CartOrder canEdit={false} cart={this.state.cart} setCart={cart => this.handleSetCart(cart)} />
                    <div style={{ marginTop: '30px' }}>
                        <Row>
                            
                            <Col size='12 6' float='right' text='right'>
                                {this.state.loadingSubmitCart ? (
                                    <Loading />
                                ) : (
                                    <Button theme='primary' onClick={() => this.handleSaveOrder()}>Reservar e completar pagamento</Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            )


        const data = this.state.data

        const guests = []
        for (let i = 0; i < parseInt(data.max_guests, 10); i++) {
            guests.push(i + 1)
        }

        return (
            <div>
                <div style={{ cursor: 'pointer' }} onClick={() => this.openImage(0)}>
                    <ImageRatio ratio='2x1' image={`${window.config.url_event_extras_images}${data.image}`}>
                        <div className={s.imageContent}>
                            <Row>
                                <Col size="6">
                                    <div className={s.price} style={{ marginTop: '10px' }}>
                                        <small>A partir de: </small>
                                        <br />
                                        R$ {numberFormat(data.starting_value, 2, ',', '.')}
                                    </div>
                                </Col>
                                <Col size="6">
                                    <span style={{ float: 'right' }}>
                                        {data.images.map((image, key) => (
                                            <div key={image.id} className={s.imagePreview} onClick={() => this.openImage(key)}>
                                                <ImageRatio ratio='1x1' image={`${window.config.url_event_extras_images}${image.image}`}></ImageRatio>
                                            </div>
                                        ))}
                                    </span>
                                </Col>
                            </Row>
                        </div>
                    </ImageRatio>
                </div>


                <div className={s.title}>
                    {data.description}
                </div>

                <BoxAccordion style={{ color: '#4a4a4a', fontSize: '14px', minHeight: '100px' }} height='100px' show={this.state.fullDescription}>
                    {data.long_description}
                </BoxAccordion>
                <div className={s.showmore} onClick={() => this.setState({
                    fullDescription: !this.state.fullDescription
                })}>
                    {this.state.fullDescription ? `ver menos` : `ver mais`}
                </div>

                <div className={s.filter}>
                    <Row className={s.verticalAlign}>
                        <Col size='5'>
                            <span>Acomodações:</span>
                        </Col>
                        <Col size='7' text='right'>
                            <Row className={s.verticalAlign}>
                                <Col size='8'>
                                    <span>Quantas pessoas iram se hospedar?</span>
                                </Col>
                                <Col size='4'>
                                    <Select value={this.state.guests} handleChange={evt => this.setState({
                                        guests: evt.target.value
                                    })}>
                                        {guests.map(i =>
                                            <option key={i}>{i}</option>
                                        )}
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

                {data.options
                    .filter(value => parseInt(value.max_guests, 10) >= this.state.guests)
                    .map(option => (
                        <div key={option.id} className={s.room}>
                            <Room handleChosen={() => this.handleChosenRoom(option.id)} data={option} guests={this.state.guests} />
                        </div>
                    ))}


                <ImageLightBox handleClose={() => {
                    this.setState({
                        lightBox: false
                    })
                }}
                    isOpen={this.state.lightBox}
                    images={this.state.images}
                    photoIndex={this.state.indexImageLightBox} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    login: state.login
})
const mapDispatchToProps = {
    openModal
}
export default connect(mapStateToProps, mapDispatchToProps)(Accommodation)



// WEBPACK FOOTER //
// ./src/components/templates/Event/ListHotel/Accommodation/index.js